var _desc, _defs, _rect, _rect2, _circle, _circle2, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileAvatarNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55.25,
    height: 55.25,
    viewBox: "0 0 55.25 55.25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "austin-wade-X6Uj51n5CE8-unsplash",
    rx: 27.625,
    width: 55.25,
    height: 55.25,
    fill: "#394D65",
    fillOpacity: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "austin-wade-X6Uj51n5CE8-unsplash",
    x: 0.5,
    y: 0.5,
    rx: 27.125,
    width: 54.25,
    height: 54.25,
    stroke: "#707070",
    strokeOpacity: 0,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 108",
    cx: 26.990723,
    cy: 18.416519,
    r: 4.911111,
    fill: "#000000",
    fillOpacity: 0
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 108",
    cx: 26.990723,
    cy: 18.416519,
    r: 4.911111,
    stroke: "#FFFFFF",
    strokeOpacity: 1,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path 371",
    d: "",
    fill: "#000000",
    fillOpacity: 0,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path 371",
    d: "M31 27.42C29.77 26.89 28.41 26.6 26.99 26.6C21.47 26.6 16.99 30.96 16.77 36.42L26.68 36.42",
    stroke: "#FFFFFF",
    strokeOpacity: 1,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path 372",
    d: "M34.05 35.6L30.77 36.42L31.59 33.14L38.14 26.6L40.59 29.05L34.05 35.6Z",
    fill: "#000000",
    fillOpacity: 0,
    fillRule: "nonzero"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path 372",
    d: "M30.77 36.42L31.59 33.14L38.14 26.6L40.59 29.05L34.05 35.6L30.77 36.42Z",
    stroke: "#FFFFFF",
    strokeOpacity: 1,
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileAvatarNew);
export default __webpack_public_path__ + "static/media/profile_avatar_new.d18f8f1d35f85c8f9da3027428ba28bd.svg";
export { ForwardRef as ReactComponent };